import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import AttachmentViewer from "./AttachmentViewer";
import { CloseIcon } from "../icons/ActionIcons";
import PropTypes from "prop-types";

export default function AttachmentViewerModal({ open, onClose, attachmentId }) {
  return (
    <Dialog open={open && attachmentId > 0} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>Liite</DialogTitle>
      <IconButton onClick={onClose} style={{ position: "absolute", right: 5, top: 5 }}>
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <AttachmentViewer attachmentId={attachmentId} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Sulje
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AttachmentViewerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  attachmentId: PropTypes.number,
};
